<template>
  <input
    class="w-full rounded-md border-bg-1 bg-bg-1 px-2 pb-[5px] pt-[6px] text-center text-[11px] font-medium leading-4 text-lgmx_black-100 placeholder:text-lgmx_gray-800 focus:border-none focus:bg-white focus:outline-none focus:ring-1 focus:ring-lgmx_gray-300 placeholder-shown:focus:text-lgmx_gray-800"
    max-length="3"
  />
</template>

<script setup></script>
